import styled from 'react-emotion';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const SortType = styled.div`
  color: ${colors.designSystem.purple70};
  cursor: pointer;
  display: flex;
  font-family: ${theme.font.family.workSans};
  line-height: 16px;
  font-size: ${theme.font.size.copy};
  font-style: normal;
  font-weight: ${theme.font.weight.semiBold};

  & span:first-child {
    margin-right: 6.5px;
    text-align: right;
  }

  & span {
    display: flex;
    font-weight: ${theme.font.weight.semiBold};
  }
`;

export const SortListItem = styled(ListItem)`
  color: ${colors.designSystem.blackOpacity87};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.large};
  padding: 8px 16px;
`;
